export default class Google {
    constructor($filter, $rootScope, $q, $location, SweetAlert) {
        this._filter = $filter;
        this._rootScope = $rootScope;
        this._q = $q;
        this._location = $location;
        this._sweetAlert = SweetAlert;

        this.auth2 = null;
        this.environment = $location.host();
        this.google_scope = 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/plus.me https://www.googleapis.com/auth/analytics.readonly';
        this.auth_button = 'google-oauth';
        this.ga_start_date = '2005-01-01';

        if (this.environment === 'rule-dev') {
            this.client_id = '1067170898485-j21cmocvfncogtj63j6piqptsqgme2u5.apps.googleusercontent.com';
            this.redirect_url = 'http://rule-dev';
        } else if (this.environment === 'staging.rule.io') {
            this.client_id = '882344101616-fotkq9o3l4ir7fi40cbjuhs5hjmacjrk.apps.googleusercontent.com';
            this.redirect_url = 'https://staging.rule.io';
        } else if (this.environment === 'app.rule.io') {
            this.client_id = '920744154335-n5vv4g1spqou2cmadd12al27r3mdc5mt.apps.googleusercontent.com';
            this.redirect_url = this._location.$$protocol + '://app.rule.io';
        }

        this.auth = {
            goals : {},
            profiles : [],
            profilePromise : [],
            counter : 0,
            requests : [],
            goalsPromises : {},
            user : '',
            metrics: [
                'sessions', 'percentageSessions', 'bounceRate', 'goalConversionAll', 'revenue', 'transactions'
            ],

            setDates : (start_date, end_date) => {
                this.auth.start_date = moment(start_date).format('YYYY-MM-DD');
                this.auth.end_date = moment(end_date).format('YYYY-MM-DD');

                // Check if our start_date not less then GA creation date
                if (moment(this.auth.start_date).isBefore(moment(this.ga_start_date))) {
                    this.auth.start_date = moment(this.ga_start_date).format('YYYY-MM-DD');
                }
                this.auth.end_date =  moment(end_date).format('YYYY-MM-DD');
            },



            auth : () => {
                gapi.load('client:auth2', () => {
                    this.auth2 = gapi.auth2.init({
                        response_type: 'code',
                        client_id: this.client_id,
                        redirect_uri: this.redirect_url,
                        'scope': this.google_scope
                    }).then(() => {
                        this.auth2 = gapi.auth2.getAuthInstance();
                        this.auth2.then(() => {
                            this.auth.attachSignin(this.auth_button);
                        });
                    });
                });
            },

            attachSignin : () => {
                gapi.signin2.render(this.auth_button, {
                    'width': 300,
                    'height': 50,
                    'longtitle': false,
                    'theme': 'dark',
                    'onsuccess': this.auth.handleAuthResult,
                    'onfailure': this.auth.handleFailure
                });
            },

            handleFailure : () => {
                // TODO: implement handler
            },

            handleAuthResult : (authResult) => {
                if (authResult && !authResult.error) {
                    this.auth.makeApiCall();
                }
            },

            makeApiCall : () => {
                gapi.client.load('analytics', 'v3')
                    .then(() => {
                        gapi.client.analytics.management.accounts.list()
                            .then(this.auth.handleAccounts);
                });
            },

            handleAccounts : (response) => {
                // Get current google user
                this.auth.user = response.result.username;

                //clear data from previous auth
                this.auth.resetData();
                // Handles the response from the accounts list method.
                if (response.result.items && response.result.items.length) {
                    let accounts = response.result.items;
                    let totalAccounts = Object.keys(accounts).length;

                    for (let i = 0; i < totalAccounts; i++) {
                        // Query for properties.
                        this.auth.queryProperties(accounts[i].id);
                    }
                } else {
                    this._sweetAlert.swal({
                        title: 'error',
                        text: this._filter('translate')('STATISTIC:INDEX:NO_ACCOUNTS'),
                        type: 'error'
                    });
                }
            },

            queryProperties : (accountId) => {
                // Get a list of all the properties for the account.
                gapi.client.analytics.management.webproperties.list(
                    {'accountId': accountId})
                    .then(this.auth.handleProperties)
                    .then(null, (err) => {
                        // Log any errors.
                        this._sweetAlert.swal({
                            title: 'error',
                            text: this._filter('translate')('STATISTIC:INDEX:WRONG_PROPERTIES'),
                            type: 'error'
                        });
                    });
            },

            handleProperties : (response) => {
                // Handles the response from the webproperties list method.
                if (response.result.items && response.result.items.length) {
                    let properties = response.result.items;
                    for (let i = 0; i < Object.keys(properties).length; i++) {
                        this.auth.queryProfiles(properties[i].accountId, properties[i].id);
                    }
                } else {
                    this._sweetAlert.swal({
                        title: 'error',
                        text: this._filter('translate')('STATISTIC:INDEX:EMPTY_PROPERTIES'),
                        type: 'error'
                    });
                }
            },

            queryProfiles : (accountId, propertyId) => {
                // Get a list of all Views (Profiles) for the property
                // of the Account.
                this.auth.profilePromise.push(
                    gapi.client.analytics.management.profiles.list({
                        'accountId': accountId,
                        'webPropertyId': propertyId
                    })
                );
                Promise.all(this.auth.profilePromise)
                    .then(this.auth.handleProfiles)
                    .then(null, (err) => {
                        this._sweetAlert.swal({
                            title: 'error',
                            text: this._filter('translate')('STATISTIC:INDEX:WRONG_PROFILES'),
                            type: 'error'
                        });
                    });
            },

            handleProfiles : (response) => {
                // Handles the response from the profiles list method.
                if (response.length === this.auth.profilePromise.length) {
                    for (let j = 0; j < response.length; j++) {
                        if (response[j].result.items && response[j].result.items.length) {
                            for (let i = 0; i < response[j].result.items.length; i++) {
                                let profile = response[j].result.items[i];
                                this.auth.profiles.push({
                                    'profileId' : profile.id,
                                    'accountId' : profile.accountId,
                                    'webProperty' : profile.webPropertyId,
                                    'name' : profile.name,
                                    'websiteUrl' : profile.websiteUrl
                                });
                            }
                        } else {
                            this._sweetAlert.swal({
                                title: 'error',
                                text: this._filter('translate')('STATISTIC:INDEX:PROFILE_NOT_FOUND'),
                                type: 'error'
                            });
                        }
                    }
                    this._rootScope.$broadcast('profiles:got');
                    this._rootScope.$apply();
                }

            },

            getGoogleData : (profileId, utm) => {
                gapi.client.load('https://analyticsreporting.googleapis.com/$discovery/rest', 'v4')
                    .then(() => {
                        if(profileId && profileId !== 'none') {
                            gapi.client.analyticsreporting.reports.batchGet({
                                "reportRequests":[
                                    {
                                        "viewId": profileId,
                                        "dateRanges":[
                                            {
                                                "startDate": this.auth.start_date,
                                                "endDate": this.auth.end_date
                                            }],
                                        "metrics":[
                                            {
                                                "expression":"ga:sessions"
                                            },
                                            {
                                                "expression":"ga:percentNewSessions"
                                            },
                                            {
                                                "expression":"ga:bounceRate"
                                            },
                                            {
                                                "expression":"ga:goalConversionRateAll"
                                            },
                                            {
                                                "expression": "ga:transactionRevenue"
                                            },
                                            {
                                                "expression": "ga:transactions"
                                            }
                                        ],
                                        "filtersExpression":"ga:campaign==" + utm
                                    }]
                            })
                                .then((response) => {
                                    let goal = this.auth.setDataNames(response.result.reports[0].data.totals[0].values);
                                    let defer = this._q.defer();
                                    defer.resolve(goal);

                                    this.auth.goalsPromises[utm] = defer.promise;

                                    return this.auth.goalsPromises;
                                }).then((promises) => {
                                this._q.all(promises).then((goals) => {
                                    this._rootScope.$broadcast('goals:got', goals);
                                    })
                                });
                        }
                    });
            },

            setDataNames : (goals) => {
                let named = {};
                if(goals.length > 0) {
                    for (let i = 0; i < goals.length; i++) {
                        let value;
                        if (goals[i] % 1 === 0) {
                            value = goals[i];
                        } else {
                            value = this._filter('number')(goals[i]);
                        }
                        named[this.auth.metrics[i]] = value;
                    }
                }
                goals = named;

                return goals;
            },

            resetData : () => {
                this.auth.profiles = [];
                this.auth.profilePromise = [];
                this.auth.requests = [];
            },

            resetGoals: () => {
                this.auth.goals = false;
            },

            getCurrentUser : () => {
                return this.auth.user ? this.auth.user : false;
            },

            getProfiles : () => {
                return this.auth.profiles ? this.auth.profiles : false;
            },

            setUtms : (utms) => {
                this.auth.utms = utms;
            },

            getTotals : (cached) => {
                let goals = cached ? cached : this.auth.goals;

                let totals = [];
                let count = 0;

                totals['sessions'] = 0;
                totals['percentageSessions'] = 0;
                totals['bounceRate'] = 0;
                totals['goalConversionAll'] = 0;
                totals['transactionRevenue'] = 0;
                totals['transactions'] = 0;

                angular.forEach(goals, function(goal) {
                    count++;
                    totals['sessions'] += goal.sessions ? +goal.sessions: 0;
                    totals['percentageSessions'] += goal.percentageSessions ? +goal.percentageSessions : 0;
                    totals['bounceRate'] += goal.bounceRate ? +goal.bounceRate : 0;
                    totals['goalConversionAll'] += goal.goalConversionAll ? +goal.goalConversionAll : 0;
                    totals['transactionRevenue'] += goal.transactionRevenue ? +goal.transactionRevenue : 0;
                    totals['transactions'] += goal.transactions ? +goal.transactions : 0;
                });

                totals['goalConversionAll'] /= (count !== 0) ? count : 1;
                totals['percentageSessions'] /= (count !== 0) ? count : 1;
                totals['bounceRate'] /= (count !== 0) ? count : 1;

                return totals;
            }
        };

        return this.auth;
    }
}